import './FooterStyle.css'

function Footer() {
 return (
  <div className="footer-box" >
   <span>&copy;Alexkpot {new Date().getFullYear()}.</span>
  </div>
 )
}

export default Footer;